import {BigId, ColonistOneTimePurchaseType} from '@colonist/types'
import {UIStoreGiftOverlayController} from '../../../../../shared/scripts/store/gift/UIStoreGiftOverlayController'
import {UIMMobileWebviewCommunication} from '../../../ui_mobile_communication/UIMMobileWebviewCommunication'
import {MobileWebviewCommunicationActions} from '@colonist/mobile'
import {GiftPurchaseData} from '../../../../../../shared/store/GiftPurchaseData'
import {UIMDeviceHandler} from '../../UIMDeviceHandler'
import {ClientUserState} from '../../../../../shared/scripts/ClientUserState'
import {ColonistGiftMembershipProduct} from '../../../../../../shared/store/ColonistGiftMembershipProduct'
import {UIAPIEndpoints} from '../../../../../shared/scripts/network/UIAPIEndpoints'
import {UIAjaxWrapper} from '../../../../../shared/scripts/network/UIAjaxWrapper'

export class UIMStoreGiftOverlayController extends UIStoreGiftOverlayController {
    protected async executeCheckout(giftTier: ColonistOneTimePurchaseType, giftPurchaseData: GiftPurchaseData) {
        const allProducts = ColonistGiftMembershipProduct.getAllMembershipProducts()
        const selectedProduct = allProducts.find((product) => product.oneTimePurchaseType == giftTier)
        if(UIMDeviceHandler.shouldEnableNativePaymentsOnMobile() && ClientUserState.userState && selectedProduct) {
            const result = await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiSaveGiftMetadata(), undefined, giftPurchaseData)
            if(result == undefined) return

            const giftMetadataId = result.json as BigId
            UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.GiftMembership, {productId: selectedProduct.mobileIAPSKUId, metadataId: giftMetadataId})
            return
        }
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.ShowTopBottomSafeArea, true)
        await super.executeCheckout(giftTier, giftPurchaseData)
    }
}
